import React from 'react'

const TestimonialsCard = ({
    image,
    title,
    subtitle,
    text
}) => {
    return (
        <div className="testimonials-card">
            <div className="info-container">
                <img src={image} alt={title} />
                <div className="title-wrapper">
                    <h6 className="title">{title}</h6>
                    <p className="subtitle">{subtitle}</p>
                </div>
            </div>
            <div className="text-wrapper">
                <p className="text">{text}</p>
            </div>
        </div>
    )
}

export default TestimonialsCard
